import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    // 登陆状态
    isLogin: false,
    crumbArr: [], // 面包屑导航栏的数据
    iframeUrl: '', // iframe的url
    managerId: '', // 登录接口返回的管家managerId
    memberId: '' // 当前查询用户的memberId
  },
  mutations: {
    setManagerId (state, payload) { // 登录接口返回的管家managerId
      state.managerId = payload;
    }
  },
  getters: {
  },
  actions: {
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js